export function timeToMinutes(time) {
  const [hours, minutes] = String(time || '00:00').split(':').map(Number);
  return hours * 60 + minutes;
}

export function formatDuration(minutes) {
  const hours = Math.floor(minutes / 60);
  const rest = minutes % 60;
  if (!hours) return `${rest} min`;
  return rest ? `${hours}h${String(rest).padStart(2, '0')}` : `${hours}h`;
}

export function mergeScheduleSlots(slots = []) {
  const grouped = new Map();
  for (const slot of slots) {
    const key = `${slot.date}|${slot.user_id}|${slot.status}`;
    if (!grouped.has(key)) grouped.set(key, []);
    grouped.get(key).push(slot);
  }

  const merged = [];
  for (const group of grouped.values()) {
    group.sort((a, b) => timeToMinutes(a.start_time) - timeToMinutes(b.start_time));
    for (const slot of group) {
      const previous = merged[merged.length - 1];
      if (
        previous
        && previous.date === slot.date
        && previous.user_id === slot.user_id
        && previous.status === slot.status
        && timeToMinutes(slot.start_time) <= timeToMinutes(previous.end_time)
      ) {
        if (timeToMinutes(slot.end_time) > timeToMinutes(previous.end_time)) previous.end_time = slot.end_time;
        previous.source_ids.push(slot.id);
      } else {
        merged.push({ ...slot, source_ids: [slot.id] });
      }
    }
  }

  return merged.sort((a, b) => (
    a.date.localeCompare(b.date)
    || timeToMinutes(a.start_time) - timeToMinutes(b.start_time)
    || a.username.localeCompare(b.username)
  ));
}

function overlaps(a, b) {
  return timeToMinutes(a.start_time) < timeToMinutes(b.end_time)
    && timeToMinutes(a.end_time) > timeToMinutes(b.start_time);
}

export function decorateDayEvents(events = []) {
  const ordered = [...events].sort((a, b) => (
    timeToMinutes(a.start_time) - timeToMinutes(b.start_time)
    || timeToMinutes(b.end_time) - timeToMinutes(a.end_time)
  ));
  const laneEnds = [-Infinity, -Infinity];

  return ordered.map((event, index) => {
    const start = timeToMinutes(event.start_time);
    const lane = laneEnds[0] <= start ? 0 : 1;
    laneEnds[lane] = timeToMinutes(event.end_time);
    const hasOverlap = ordered.some((candidate, candidateIndex) => candidateIndex !== index && overlaps(event, candidate));
    return { ...event, lane, hasOverlap };
  });
}

export function derivePauses(events = []) {
  const groups = new Map();
  for (const event of events.filter(item => item.status === 'present')) {
    if (!groups.has(event.user_id)) groups.set(event.user_id, []);
    groups.get(event.user_id).push(event);
  }

  const pauses = [];
  for (const group of groups.values()) {
    group.sort((a, b) => timeToMinutes(a.start_time) - timeToMinutes(b.start_time));
    for (let index = 0; index < group.length - 1; index += 1) {
      const current = group[index];
      const next = group[index + 1];
      const gap = timeToMinutes(next.start_time) - timeToMinutes(current.end_time);
      if (gap >= 30 && gap <= 120) {
        pauses.push({
          id: `pause-${current.user_id}-${current.date}-${current.end_time}`,
          date: current.date,
          user_id: current.user_id,
          username: current.username,
          user_color: current.user_color,
          start_time: current.end_time,
          end_time: next.start_time,
          lane: current.lane || 0,
          hasOverlap: current.hasOverlap || next.hasOverlap,
          status: 'pause',
        });
      }
    }
  }
  return pauses;
}
